// extracted by mini-css-extract-plugin
module.exports = {"body":"RequestsList_body__1Nj8y"};